module.exports = __webpack_public_path__ + "static/limítrofe-530aa5e95f5b715fe9eeb69e79a41579.png";